import { useEffect } from 'react'
import { getPlans } from '../services'
import { usePlanStore } from '../store'

export const useGetPlans = () => {
  const isLoading = usePlanStore((state) => state.isLoading)
  const setIsLoading = usePlanStore((state) => state.setIsLoading)
  const plans = usePlanStore((state) => state.plans)
  const setPlans = usePlanStore((state) => state.setPlans)
  const isError = usePlanStore((state) => state.isError)
  const setIsError = usePlanStore((state) => state.setIsError)

  const fetchPlans = async () => {
    setIsLoading(true)
    try {
      const response = await getPlans()
      if (response.isSuccess && response.data) {
        setPlans(response?.data)
        setIsError(false)
      } else {
        setIsError(true)
      }
    } catch {
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (!plans && !isError && !isLoading) {
      fetchPlans()
    }
  }, [plans])

  return {
    fetchPlans,
    isLoading,
    plans,
    isError
  }
}
